/**
 * influencers: how a chart point of each widget maps back to the rows behind it,
 * for the conversations drill-down. Same filtering as the widget's loader.
 */
import type { DrillResolvers } from './types';

export const influencersDrillResolvers: DrillResolvers = {};
